import { render, staticRenderFns } from "./Partner_Confirmation.vue?vue&type=template&id=15052b6a&scoped=true&"
import script from "./Partner_Confirmation.vue?vue&type=script&lang=js&"
export * from "./Partner_Confirmation.vue?vue&type=script&lang=js&"
import style0 from "./Partner_Confirmation.vue?vue&type=style&index=0&id=15052b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15052b6a",
  null
  
)

export default component.exports